import Button from "components/Button";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import classes from "./ErrorBoundary.module.scss";

const ErrorBoundary: FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.message}>
          <h1 className={classes.title}>{i18n.t("oops")}</h1>
          <p className={classes.description}>{i18n.t("errorMessage")}</p>
        </div>

        <div className={classes.actions}>
          <Button
            onClick={() => navigate(0)}
            type="primary"
            className={classes.primaryAction}
          >
            {i18n.t("reload")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
